import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Skeleton } from '@mui/material';
import DashboardCountCardView from '../../../components/Dashboard/HrComponents/DashboardCountCardView';
import { useDispatch, useSelector } from 'react-redux';
import { getAllhrDashboardCounts } from '../../../redux/features/hrDashboard';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

const NewCardViewComponents = React.memo(() => {
  const { hrDashboardCounts, loading } = useSelector((store) => store.hrDashboard);
  const dispatch = useDispatch();
  const [today, setToday] = useState(dayjs());
  const navigate = useNavigate();

  const clickFunction = useCallback((title) => {
    //THIS FUNCTION WILL TAKESPLACE TITLE NAME OF EACH CARD TO OPEN IN GLOBAL MODAL

    if (title == 'Total Employees') {
      navigate('/my-workspace/all-users');
    } else if (title == 'Male Employees') {
      navigate('/my-workspace/all-users', {
        state: { genderFilter: ['Male'] },
      });
    } else if (title == 'Female Employees') {
      navigate('/my-workspace/all-users', {
        state: { genderFilter: ['Female'] },
      });
    } else if (title == 'Permanent Employees') {
      navigate('/my-workspace/all-users', {
        state: { employeTypeFilter: ['Permanent'] },
      });
    } else if (title == 'Notice Period Employees') {
      navigate('/my-workspace/all-users', {
        state: { employeTypeFilter: ['Notice Period'] },
      });
    } else if (title == 'Probation Employees') {
      navigate('/my-workspace/all-users', {
        state: { employeTypeFilter: ['Probation'] },
      });
    } else if (title == 'Resigned Employees') {
      navigate('/my-workspace/all-users', {
        state: { employeeStatusFilter: ['Resigned'] },
      });
    } else if (title == 'Today Leave') {
      navigate('/my-workspace/all-users', {
        state: {
          leaveFilter: [
            'Compensatory Off',
            'Leave-Casual Leave',
            'Leave-Sick Leave',
            'Leave-Paid Leave',
            'Leave-Maternity Leave',
            'Leave Without Pay',
            'Leave-Dot Leave',
            'Leave-Earned Leave',
          ],
          genderFilter: ['Male', 'Female'],
        },
      });
    } else if (title == 'Long Leave Employees') {
      navigate('/my-workspace/all-users', {
        state: { employeeStatusFilter: ['Long Leave'] },
      });
    } else if (title == 'Today Present') {
      navigate('/my-workspace/all-users', {
        state: { attendenceFilter: ['Present Marked'] },
      });
    } else if (title == 'Today Work From Home') {
      navigate('/my-workspace/all-users', {
        state: { leaveFilter: ['Work From Home (WFH)'] },
      });
    } else if (title == 'Lunch Count') {
      navigate('/my-workspace/food', {
        state: { categoryFilter: 1 },
      });
    } else if (title == 'Evening Food Count') {
      navigate('/my-workspace/food', {
        state: { categoryFilter: 2 },
      });
    } else if (title == 'Post Working Employes') {
      navigate('/my-workspace/post-working-hours');
    } else if (title == 'Magic Lamp Employees') {
      navigate('/my-workspace/all-users', {
        state: {
          departmentFilter: ['MAGIC LAMP(D2C)'],
        },
      });
    } else if (title == 'SkillX Employees') {
      navigate('/my-workspace/all-users', {
        state: {
          departmentFilter: ['SkillX'],
        },
      });
    }
    else if (title == 'Interval Employees') {
      navigate('/my-workspace/all-users', {
        state: {
          // departmentFilter: ['SkillX'],
          excludeDeptNames:['SkillX','MAGIC LAMP(D2C)','Skillx']
        },
      });
    }
  }, []);

  useEffect(() => {
    // if(hrDashboardCounts?.TotalEmployees==0){ //IF THERE IS NO EMPLOYEE IN THE DATABASE THEN NO API CALL WILL BE MADE
    dispatch(getAllhrDashboardCounts(today.format('YYYY-MM-DD'))); //API FOR ONLY SHOWING COUNTS ON CARDS
    // }
  }, []);

  return (
    <Box>
      <Grid container spacing={4}>
        {loading ? (
          <DashboardCountCardSkeleton />
        ) : (
          <>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Total Employees"
                total={hrDashboardCounts?.TotalEmployees}
                icon={'clarity:group-solid'}
                color="s1"
                clickFunction={clickFunction}
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Interval Employees"
                total={hrDashboardCounts?.intervalEmployees}
                color="s2"
                icon={'clarity:employee-group-solid'}
                clickFunction={clickFunction}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Magic Lamp Employees"
                total={hrDashboardCounts?.magicLampEmployees}
                color="s3"
                icon={'temaki:board-train-kids'}
                clickFunction={clickFunction}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="SkillX Employees"
                total={hrDashboardCounts?.skillXEmployees}
                color="s4"
                icon={'entypo:bar-graph'}
                clickFunction={clickFunction}
              />
            </Grid>


            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Male Employees"
                total={hrDashboardCounts?.totalMaleEmployees}
                color="t1"
                icon={'ic:outline-male'}
                clickFunction={clickFunction}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Female Employees"
                total={hrDashboardCounts?.totalFemaleEmployees}
                color="t2"
                icon={'game-icons:female'}
                clickFunction={clickFunction}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Permanent Employees"
                total={hrDashboardCounts?.permanentEmployee}
                color="t3"
                icon={'game-icons:strong'}
                clickFunction={clickFunction}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Post Working Employes"
                total={hrDashboardCounts?.postWorkingHours}
                color="t4"
                icon={'arcticons:nightmode'}
                clickFunction={clickFunction}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Notice Period Employees"
                total={hrDashboardCounts?.noticeEmployee}
                color="z5"
                icon={'ooui:user-temporary-rtl'}
                clickFunction={clickFunction}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Probation Employees"
                total={hrDashboardCounts?.probationEmployee}
                color="z6"
                icon={'fluent-mdl2:temporary-user'}
                clickFunction={clickFunction}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Long Leave Employees"
                total={hrDashboardCounts?.totalLongLeaveEmployees}
                color="z7"
                icon={'lsicon:user-leave-filled'}
                clickFunction={clickFunction}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Resigned Employees"
                total={hrDashboardCounts?.totalResignedEmployees}
                color="z8"
                icon={'streamline:emergency-exit-solid'}
                clickFunction={clickFunction}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Today Present"
                total={hrDashboardCounts?.today_present}
                color="p4"
                icon={'ic:round-event-available'}
                clickFunction={clickFunction}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Today Leave"
                total={hrDashboardCounts?.totalLeaves}
                color="p2"
                icon={'iconamoon:calendar-remove-bold'}
                clickFunction={clickFunction}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Today Work From Home"
                total={hrDashboardCounts?.totalWFH}
                color="p3"
                icon={'mdi:home-account'}
                clickFunction={clickFunction}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Lunch Count"
                total={hrDashboardCounts?.lunch_count}
                color="p1"
                icon={'fluent:food-32-filled'}
                clickFunction={clickFunction}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCountCardView
                title="Evening Food Count"
                total={hrDashboardCounts?.evening_food_count}
                color="p6"
                icon={'cil:fastfood'}
                clickFunction={clickFunction}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
});
export const DashboardCountCardSkeleton = () => {
  return (
    <Box sx={{ px: 4 }}>
      <Grid container spacing={3}>
        {Array.from(new Array(16)).map((_, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Skeleton
              animation="wave"
              sx={{
                width: 270,
                height: 200,
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default NewCardViewComponents;
